import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiRequest } from '@/shared/api'
import type { TagEntityKind } from '../model/types'
import { TagsSchema } from '../model/types'
import { tagKeys } from './queries'

// Замена тегов сущности целиком (PUT, [] очищает). Инвалидируем весь
// query-namespace сущности (её read-view несут tags) и словарь подсказок
// (usage_count сместился).
export function useSetEntityTags(entityKind: TagEntityKind, entityId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (tags: string[]) => {
      const body = await apiRequest<{ tags: unknown }>({
        method: 'PUT',
        url: `/tags/${entityKind}/${entityId}`,
        body: { tags },
      })
      // Бэк отдаёт nil-срез как null при полной очистке ([] → null) — коалесим в [].
      return TagsSchema.parse(body.tags ?? [])
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: [entityKind] })
      void qc.invalidateQueries({ queryKey: tagKeys.all })
    },
  })
}
